import { Icon } from 'components/project/ClerkScreen';
import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { getTranslation } from 'shared/language';
import { getStreamerHost } from '../../../endpoints';
import { Container, Link, Title } from './Styles';

const LayoutSettings = () => {
  const {
    AuctionStore: {
      layoutSettings,
      laneMediaSettings: { streamer },
    },
    ProviderStore: { language },
  } = useStores();

  const screens = layoutSettings;

  const {
    screen: {
      login: { selectScreenHeaderText },
    },
  } = getTranslation(language);

  window.name = 'login';

  const handleClick = (route) => {
    window.location.href = `/${route}`;
  };

  return (
    <Container>
      <Title>{selectScreenHeaderText}</Title>
      {screens && screens.length === 0 && (
        <div>
          <Icon icon="exclamation-triangle" iconOnly size={1} />
          Oops! It appears that layout settings do not exist, currently! Please
          contact technical support if you feel this is an error.
        </div>
      )}
      {screens
        ?.filter((item) => item.layoutType !== 'Bidder')
        .map((item) => (
          <Link
            data-testid={`btn-${item.layout}`}
            key={item.layoutID}
            onClick={(e) => {
              e.preventDefault();
              handleClick(item.slug);
            }}
          >
            {item.layout?.replace('NPA Vehicle ', '')}
          </Link>
        ))}
      <Link
        data-testid="btn-streamer"
        key={10}
        onClick={(e) => {
          e.preventDefault();
          window.open(getStreamerHost(), 'streamerWindow', '');
        }}
        target="_blank"
      >
        Audio Streamer
        {streamer && (
          <div style={{ fontSize: '.75em', color: '#fff' }}>{streamer}</div>
        )}
      </Link>
    </Container>
  );
};

export default observer(LayoutSettings);
